import { ErrorCode } from '@/configs/errorCode';
import { ApiError } from '@/types/types';
import axios, { AxiosError, HttpStatusCode, isAxiosError } from 'axios';
import { getAuthToken } from '@/utils/auth';

const httpClient = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	headers: {
		Accept: 'application/json',
		'Content-type': 'application/json; charset=UTF-8',
	},
});

httpClient.interceptors.request.use((request) => {
	if (request.data instanceof FormData) request.headers.setContentType('');
	const token = getAuthToken();
	if (token) {
		request.headers = request.headers ?? {};
		request.headers.Authorization = `Bearer ${token}`;
	}

	return request;
});

httpClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (isAxiosError<ApiError>(error)) {
			if (error.code === AxiosError.ECONNABORTED) throw error;

			const status = error.response?.status ?? HttpStatusCode.InternalServerError;
			const messagePayload = error.response?.data?.message;
			const stack = Array.isArray(messagePayload)
				? messagePayload
				: messagePayload
					? [messagePayload]
					: [ErrorCode.GENERIC];

			throw {
				status,
				stack,
			};
		}

		throw {
			code: HttpStatusCode.InternalServerError,
			stack: [ErrorCode.GENERIC],
		};
	}
);

export default httpClient;
